import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext({ user: undefined, login: async () => {}, logout: async () => {} });

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined = checking, null = not authed

  useEffect(() => {
    const token = localStorage.getItem("tt_admin_token");
    if (!token) { setUser(null); return; }
    api.me()
      .then((r) => { setUser(r.data.user); localStorage.setItem("tt_admin_user", JSON.stringify(r.data.user)); })
      .catch(() => { setUser(null); localStorage.removeItem("tt_admin_token"); });
  }, []);

  const login = async (email, password) => {
    const r = await api.login(email, password);
    localStorage.setItem("tt_admin_token", r.data.token);
    localStorage.setItem("tt_admin_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = async () => {
    try { await api.logout(); } catch (_) {}
    localStorage.removeItem("tt_admin_token");
    localStorage.removeItem("tt_admin_user");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
};

export const useAdminAuth = () => useContext(AuthCtx);
